<template>
  <div class="dilinkTabs">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="view"
    >
      <el-row class="row-bg" justify="space-between">
        <el-col :span="8">
          <el-form-item label="资金提供方" prop="tenandNm">
            <el-input
              :class="{ inputClass: zjfReadonly }"
              :readonly="zjfReadonly"
              v-model="ruleForm.tenandNm"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" justify="space-between">
          <el-form-item label="联系人" prop="contacter">
            <el-input
              v-model="ruleForm.contacter"
              :class="{ inputClass: isReadonly }"
              :readonly="isReadonly"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" justify="space-between">
          <el-form-item label="手机号码" prop="tel">
            <el-input
              v-model.number="ruleForm.tel"
              :class="{ inputClass: isReadonly }"
              :readonly="isReadonly"
              maxlength="11"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="8" justify="space-between">
          <el-form-item
            label="有效期类型"
            :class="isReadonly ? 'disableColor' : ''"
            prop="validDateType"
          >
            <el-select
              v-if="$route.query.opType && $route.query.opType != 0"
              v-model="ruleForm.validDateType"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="isReadonly"
              >
              </el-option>
            </el-select>
            <el-input
              v-else
              :class="{ inputClass: isReadonly }"
              :readonly="isReadonly"
              :value="validDateTypename(ruleForm.validDateType)"
            >
              <!-- v-model="ruleForm.validDateType =='1Y' ? '自然年' : ruleForm.validDateType =='1Z' ? '周期年': ruleForm.validDateType =='F' ? '永久' :''"  -->
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label=""> </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="18">
          <el-form-item label="评估说明" prop="rmrk">
            <el-input
              class="textareaclass"
              type="textarea"
              v-model="ruleForm.rmrk"
              :class="{ inputClass: isReadonly }"
              :readonly="isReadonly"
              :rows="3"
              placeholder="最多输入200个字"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="6">
          <el-form-item label=""> </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label=""> </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="24">
          <div class="footerBtn">
            <el-button type="primary" @click="onSubmit()">下一步</el-button>
            <el-button @click="goPriveView">返回</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { submit } from "../reqApi";
import utif from "@/utif/utif.js";
export default {
  name: "basicInfo",
  props: {
    ruleForm: {
      type: Object,
      default() {
        return {};
      },
    },
    tenantQualParaDictEntities1: {
      type: Array,
      default() {
        return [];
      },
    },
    tenantQualParaDictEntities2: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      options1: [],
      options2: [
        {
          label: "自然年",
          value: "1Y",
        },
        {
          label: "周期年",
          value: "1Z",
        },
        {
          label: "永久",
          value: "F",
        },
      ],
      options3: [
        {
          label: "启用",
          value: "0",
        },
        {
          label: "停用",
          value: "1",
        },
      ],
      zjfReadonly: true,
      isReadonly: true,
      rules: {
        tenandNm: [
          { required: true, message: "请填写资金提供方", trigger: "blur" },
        ],
        contacter: [
          {
            required: true,
            message: "请填写联系人",
            validator: utif.validName,
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            type: "number",
            validator: utif.validPhone,
            message: "请填写正确手机号码",
            trigger: "blur",
          },
        ],

        validDateType: [
          { required: true, message: "请选择有效期类型", trigger: "change" },
        ],
        rmrk: [{ required: true, message: "请填写评估说明", trigger: "blur" }],
        state: [
          { required: true, message: "请选择启用状态", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    //新增
    if (this.$route.query.addStatus && this.$route.query.addStatus == 3) {
      // 资金方 名称不可编辑
      this.ruleForm.state = "0"; // 默认启动状态
      this.zjfReadonly = true;
      //其他可编辑
      this.isReadonly = false;
    } else {
      if (this.$route.query.opType && this.$route.query.opType == 0) {
        //查看
        //查看均不可编辑
        this.zjfReadonly = true;
        this.isReadonly = true;
      } else if (
        !this.$route.query.addStatus &&
        this.$route.query.opType == 1
      ) {
        //修改
        // 资金方 名称不可编辑
        this.zjfReadonly = true;
        this.isReadonly = false;
      }
    }
  },
  methods: {
    validDateTypename(type) {
      let value = "";
      switch (type) {
        case "1Y":
          value = "自然年";
          break;

        case "1Z":
          value = "周期年";
          break;
        case "F":
          value = "永久";
          break;
      }
      return value;
      // ruleForm.validDateType == "1Y"
      //   ? "自然年"
      //   : ruleForm.validDateType == "1Z"
      //   ? "周期年"
      //   : ruleForm.validDateType == "F"
      //   ? "永久"
      //   : "";
    },
    goPriveView() {
      this.$router.go(-1);
      // this.$router.push("/operationcenter/productManagement");
    },
    // 下一步
    onSubmit() {
      // 是否可以编辑信息
      if (this.isReadonly) {
        this.$emit("changeTab", 1);
      } else {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            //校验通过 追加首层信息
            //  this.$emit("submitfnchild", {
            //     tenantQualConfigBaseEntity: this.ruleForm,
            //     tenantQualParaDictEntities: this.tenantQualParaDictEntities1.concat(
            //       this.tenantQualParaDictEntities2
            //     ),
            //   });
            this.$emit("changeTab", 1);
          } else {
            return false;
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dilinkTabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  // padding: 0px 50px;

  form.view {
    .el-form-item {
      /deep/.el-form-item__label {
        color: #858692;
      }
      &.disableColor {
        /deep/.el-input__inner {
          //  color: #C0C4CC;
        }
      }
    }

    /deep/.inputClass {
      // background:red;
      .el-input__inner {
        border: 0;
        color: #2e2f3c;
      }
      .el-textarea__inner {
        border: 0;
        color: #2e2f3c;
        padding: 10px 15px;
      }
    }
  }
}
.footerBtn{
  display: flex;
  justify-content: center;
}
.textareaclass /deep/ .el-textarea__inner {
  min-height: 150px !important;
}

.landLineTel3 /deep/ .el-form-item__content {
  margin-left: 18px !important;
}
</style>